import PropTypes from 'prop-types';

export const FORM_VALUES_SHAPE = {
  consent: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
};

export const NEWSLETTER_SHAPE = {
  description: PropTypes.string.isRequired,
  email_id: PropTypes.string.isRequired,
  frequency: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  sms_id: PropTypes.string.isRequired,
};

export const GROUP_SHAPE = {
  items: PropTypes.arrayOf(PropTypes.shape(NEWSLETTER_SHAPE)).isRequired,
  label: PropTypes.string.isRequired,
};
